import { Booking } from "@src/BookingTools/App/AppDataProvider/types";

type Options = {
  bookingDataSelectedBookings?: Booking[];
  stepSelectedBookings: Booking[];
};

/**
 * Compares selectedBookings in bookingData and currently selected bookings
 * on this step.
 * @returns true if bookingData.selectedBookings exists, contains at least one
 *          booking and exactly matches currently selected bookings
 */
export const didUserSelectSameBookings = ({
  bookingDataSelectedBookings,
  stepSelectedBookings,
}: Options): boolean =>
  typeof bookingDataSelectedBookings !== "undefined" &&
  bookingDataSelectedBookings.length > 0 &&
  bookingDataSelectedBookings.length === stepSelectedBookings.length &&
  bookingDataSelectedBookings.every((booking1) =>
    stepSelectedBookings.some((booking2) => booking2._id === booking1._id)
  );
